import React, { useEffect, useState } from 'react';
import { ShirtIcon } from 'lucide-react';
export function Wardrobe() {
  const [isOpen, setIsOpen] = useState(false);
  const [purchasedStickers, setPurchasedStickers] = useState([]);
  const [equippedSticker, setEquippedSticker] = useState(null);
  useEffect(() => {
    const storedStickers = localStorage.getItem('purchasedStickers');
    const storedEquippedSticker = localStorage.getItem('equippedSticker');
    if (storedStickers) {
      setPurchasedStickers(JSON.parse(storedStickers));
    }
    if (storedEquippedSticker) {
      setEquippedSticker(storedEquippedSticker);
    }
  }, []);
  const stickers = [{
    id: 'fire',
    emoji: '🔥',
    name: 'Fire'
  }, {
    id: 'water',
    emoji: '💧',
    name: 'Water Drop'
  }, {
    id: 'wave',
    emoji: '🌊',
    name: 'Wave'
  }, {
    id: 'earth',
    emoji: '🌍',
    name: 'Earth'
  }, {
    id: 'camping',
    emoji: '🏕️',
    name: 'Camping'
  }, {
    id: 'desert',
    emoji: '🏜️',
    name: 'Desert'
  }, {
    id: 'national_park',
    emoji: '🏞️',
    name: 'National Park'
  }, {
    id: 'island',
    emoji: '🏝️',
    name: 'Island'
  }, {
    id: 'mountain',
    emoji: '🏔️',
    name: 'Mountain'
  }];
  const handleEquip = stickerId => {
    setEquippedSticker(stickerId === equippedSticker ? null : stickerId);
    localStorage.setItem('equippedSticker', stickerId === equippedSticker ? '' : stickerId);
  };
  return <section className="bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-700 shadow-lg" data-id="element-376">
      <button className="w-full flex items-center justify-between bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-377">
        <span className="text-xl flex items-center" data-id="element-378">
          <ShirtIcon className="w-5 h-5 mr-2" data-id="element-379" />
          Wardrobe
        </span>
        <svg className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-380">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-381"></path>
        </svg>
      </button>
      {isOpen && <div className="space-y-4 mt-4 p-2 bg-slate-700/60 rounded-lg" data-id="element-382">
          <div className="bg-slate-700/40 p-4 rounded-lg mb-4" data-id="element-383">
            <h3 className="text-xl font-semibold text-yellow-300 mb-2" data-id="element-384">
              Your Chat Stickers
            </h3>
            <p className="text-gray-300 text-sm" data-id="element-385">
              Equip a sticker to display it under your avatar in the Fanspace
              chat!
            </p>
          </div>
          {purchasedStickers.length === 0 ? <div className="text-center py-8 text-gray-300" data-id="element-386">
              <p data-id="element-387">You haven't purchased any stickers yet.</p>
              <p className="mt-2" data-id="element-388">Visit the PokéShop to buy some!</p>
            </div> : <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-id="element-389">
              {stickers.filter(sticker => purchasedStickers.includes(sticker.id)).map(sticker => <div key={sticker.id} className={`bg-slate-600/60 rounded-lg p-4 flex flex-col items-center cursor-pointer border-2 ${equippedSticker === sticker.id ? 'border-green-500' : 'border-transparent hover:border-yellow-500'}`} onClick={() => handleEquip(sticker.id)} data-id="element-390">
                    <div className="text-4xl mb-2" data-id="element-391">{sticker.emoji}</div>
                    <p className="text-white font-medium" data-id="element-392">{sticker.name}</p>
                    {equippedSticker === sticker.id && <span className="mt-2 text-green-400 text-sm" data-id="element-393">
                        Equipped
                      </span>}
                  </div>)}
            </div>}
        </div>}
    </section>;
}